import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-qppopup',
  templateUrl: './qppopup.component.html',
  styleUrls: ['./qppopup.component.scss']
})
export class QppopupComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
  }

}
